import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface ConstructionProductDocumentsServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<ConstructionProductDocumentsServiceData>(db, 'constructionProductDocumentsService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
